import { render } from "./ClientLogoForm.vue?vue&type=template&id=470a7cac&scoped=true"
import script from "./ClientLogoForm.vue?vue&type=script&lang=js"
export * from "./ClientLogoForm.vue?vue&type=script&lang=js"

import "./ClientLogoForm.vue?vue&type=style&index=0&id=470a7cac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470a7cac"]])

export default __exports__